import React, { useState } from 'react'

import {
    StyleSheet,
    View,
    Text,
    TouchableOpacity,
    ScrollView
} from 'react-native'

import {
    adaptive, typography, colors
} from '@sart/styles'

import {
    Space,
    RadioExtended,
    SelectExtended,
    Select,
    CreditCardForm,
    StoredPaymentMethod,
    Button
} from '@sart/components'

import { useContent } from '@sart/content'
import client, { useClient } from '@sart/client'
import { testID } from '@sart/utilities'

import * as theme from '../Sign/signTheme'

import { useFormik } from 'formik'
import * as Yup from 'yup'

export default function TopUp(props) {
    const { navigation, route } = props
    const content = useContent()
    const [optionSelected, setOptionSelected] = useState('storedCard')
    const hasRecurringProduct = getHasRecurringProduct()
    const requireStoring = route.params?.requireStoring

    const {
        cache: {
          storedPayment,
          cachedPayment,
          customer,
          accounts,
					language
        } = {}
      } = useClient()

    var basket
    var amount
    let paymentMethod

    if (cachedPayment !== undefined) {
        paymentMethod = cachedPayment
      } else if (paymentMethod === undefined && storedPayment !== undefined) {
        paymentMethod = storedPayment
        paymentMethod.method = 'storedDetails'
      } else {
        paymentMethod = route.params?.paymentMethod
      }

    function selectedOption(option) {
        setOptionSelected(option)
    }
    if (optionSelected === "postpaidAccount") {
        amount = "£24.97"
    }
    else if (optionSelected === "broadbandAccount") {
        amount = "£89.36"
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            totalAmount: undefined,
            ...props.initialValues
        },
        validationSchema: Yup.object().shape({
            totalAmount: Yup.string().trim().required(content.forms.required),
        }),
        onSubmit: handlePayment
    })

    function getHasRecurringProduct() {
        if (basket === undefined) {
            return false
        }
        var hasRecurringProduct = false
        for (const basketItem of basket) {
            if (basketItem.recurring === true) {
                return true
            }
        }
        return hasRecurringProduct
    }

    function handlePayment() {
        const confirmation = {
            title: content.payBill.congratulations,
            description: content.payment_confirm.topUp  + formik.values.totalAmount
        }
        navigation.navigate('Confirmation', {confirmation})
    }

    function handleChoosePayment() {
        navigation.navigate('Payment', {
          paymentMethod
        })
      }

    return (
        <ScrollView>
            <View style={styles.container}>
                <Space height={24} />

                <Select
                    label={content.topup.amount}
                    value={formik.values.totalAmount}
                    placeholder={content.payBill.selectAmount}
                    options={[
                        { value: '£5', label: "£5" },
                        { value: '£10', label: "£10" },
                        { value: '£20', label: "£20" },
                        { value: '£50', label: "£50" },
                        { value: '£100', label: "£100" },
                    ]}
                    onChange={(option) =>  formik.handleChange('totalAmount')(option.value)}
                    onOptionChange={option => {
                        formik.handleChange('totalAmount')(option.value)
                    }}
                    error={formik.touched.totalAmount && formik.errors.totalAmount}
                    labelStyle={styles.label}
                    // style={styles.selectContainer}
                    containerStyle={styles.selectContainer}
										injectedContent={content}
                    {...testID('TopUpSelectAmount')}
                />                
                
                <Space height={48} />

                <TouchableOpacity onPress={() => selectedOption('storedCard')} {...testID('TopUpStoredCard')}>
                    <View style={styles.section}>
                        <RadioExtended
                            selected={optionSelected === 'storedCard'}
                            label={"Pay with stored card"}
                            radioLabelStyle={styles.labelStyle}
                        />
                        <Space width={16} />
                    </View>

                </TouchableOpacity>

                {optionSelected === 'storedCard' &&
                <View>
                    <StoredPaymentMethod
                        payment={paymentMethod}
                        onEditPayment={handleChoosePayment}
                        containerStyle={styles.storedPaymentContainer}
                        style={styles.inputStyle}
                        footerStyle={styles.footerStyle}
												language={language}
												injectedContent={content}
                    />
                    <Space height={24} />
                    <Button 
                      title={content.navigation.topUp}
                      onPress={() => handlePayment()}
                      style={styles.enabled}
                      disabledStyle={styles.disabled}
                      titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
                      disabledTitleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.srDarkGreen + 45,
                      }}
                      {...testID('TopUpStoredCardSelect')}
                    />
                </View>
                }
                <Space height={24} />
                <TouchableOpacity onPress={() => selectedOption('debitCard')} {...testID('TopUpCard')}>
                    <View style={styles.section}>
                        <RadioExtended
                            selected={optionSelected === 'debitCard'}
                            label={"Pay with credit/debit card"}
                            radioLabelStyle={styles.labelStyle}
                        />
                        <Space width={16} />
                    </View>

                </TouchableOpacity>
                {optionSelected === 'debitCard' &&
                    <CreditCardForm
                        onCardSubmit={handlePayment}
                        switchStyle={styles.switchStyle}
                        // disabledStoring={product && !product.recurring}
                        {
                        ...((hasRecurringProduct) || requireStoring ? {
                            disableToggleStoring: true,
                            initialValues: {
                                store: true
                            }
                        } : {})
                        }
                        style={styles.creditCardFormInput}
                        disabledStyle={styles.disabled}
                        enabledStyle={styles.enabled}
                        titleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.white }}
                        disabledTitleStyle={{ ...typography.extrabold, fontSize: 18, color: colors.srDarkGreen + 45 }}
                        {...theme.textInputWhiteBackground}
                    />
                }
                <Space height={24} />

            </View>
        </ScrollView>
    )
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        ...adaptive.wrapperPadding,
    },
    amountDueText: {
        ...typography.lightbold,
        fontSize: 22,
        color: colors.srDarkGreen
    },
    section: {
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    labelStyle: {
        color: colors.srDarkGreen,
        fontSize: 20,
        ...typography.lightbold
    },
    text: {
        fontSize: 16,
        color: colors.srTextInput,
        ...typography.demi
    },
    label: {
        ...typography.demi,
        color: colors.srDarkGreen,
    },
    selectContainer: {
        borderColor: colors.srGreen,
        borderWidth: 1,
        borderRadius: 16
    },
    enabled: {
        backgroundColor: colors.srDarkGreen
    },
    disabled: {
        backgroundColor: colors.srDarkGreen + 45,
    },
})
